// extracted by mini-css-extract-plugin
module.exports = {"Head":"Obligation__Head_3jRY1","Title":"Obligation__Title_q3k7j","Description":"Obligation__Description_23OmM"};